import { DataListItem } from '@app/components/DataList'
import { ILeasePriceTerm } from '@app/models/LeasePriceTerm'
import { formatCurrency, formatNumber } from '@app/utils/formatting'
import * as React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'

interface ILeaseTermDetailsCardProps {
  actions?: React.ReactNode
  className?: string
  term: ILeasePriceTerm
  style?: React.CSSProperties
}

export default class LeaseTermDetailsCard extends React.PureComponent<
  ILeaseTermDetailsCardProps
> {
  public render() {
    return (
      <Card className={this.props.className} style={this.props.style}>
        <CardBody>
          <div className='d-flex justify-content-between align-items-baseline'>
            <CardTitle>Term: {this.props.term.term}</CardTitle>
            <div>{this.props.actions}</div>
          </div>
          <DataListItem
            label='Total $ Per Month'
            value={this.props.term.totalPerMonth}
          />
          <DataListItem
            label='Total $ Per Year'
            value={formatCurrency(this.props.term.totalPerYear, 2)}
          />
          <DataListItem
            label='Total $ Per Term'
            value={formatCurrency(this.props.term.totalPerTerm, 2)}
          />
          <DataListItem
            label='Commission Rate'
            value={`${formatNumber(this.props.term.comissionRate, 2)}%`}
          />
          <DataListItem
            label='Fees'
            value={formatCurrency(this.props.term.fees, 2)}
          />
        </CardBody>
      </Card>
    )
  }
}
